module.exports = __webpack_public_path__ + "img/convenience-1-supp.1f8aa6c5.png";